
const appStyle = (theme,) => ({
  mainPanel: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    overflow: "auto",
    position: "relative",
    float: "right",
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
    backgroundColor: "#F9F9F8",
  },
  header: {
    width: "100%",
    padding: '10px 0 0px 0px',
    textAlign: 'left',
    color: '#fff',
    backgroundImage: `url("https://shopdisneyeu.scene7.com/is/image/DisneyStoreES/34819_marvel_mania_tb?$tb$")`,
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'cover',
    backgroundSize: '100% 100%',
    height: '217px',
  },
  headerApp: {
    width: "100%",
    margin: '0px 0 20px 0px',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'cover',
    backgroundSize: '100% 100%',
    height: '217px',
  },
  headerContent: {
    margin: "40px 0 0 20px",
    width: '600px',
  },
  headerTitle: {
    fontFamily: 'Montserrat',
    fontSize: '30px',
    fontWeight: 'bold',
    width: "90%",
    background: `rgba(0, 0, 0, 0.5)`,
    padding: "10px 10px 0 10px",
  },
  headerSecondTitle: {
    color: '#00A4FF',
    lineHeight: '50px',
  },
  menu: {
    width: "100%",
    textAling: 'left',
    padding: 15,
    backgroundColor: 'white'
  },
  chipLogo: {
    height: '51px',
    width: '149px',
    textAlign: 'center',
  },
  chip: {
    fontFamily: 'Montserrat',
    fontWeight: '900',
    fontSize: '16px',
    margin: "0 5px 0 5px",
    borderColor: `rgb(255,152,109)`,
    "&:hover": {
      color: '#00A4FF'
    },
  },
  chipAppTodo: {
    fontFamily: 'Montserrat',
    fontWeight: '900',
    fontSize: '16px',
    padding: 16,
    borderColor: `rgb(255,152,109)`,
    "&:hover": {
      color: '#00A4FF'
    },
  },
  chipSub: {
    color: '#8D8D8D',
    fontFamily: 'Montserrat',
    fontWeight: '900',
    fontSize: '16px',
    margin: "0 5px 0 5px",
    borderColor: `rgb(255,152,109)`,
    "&:hover": {
      color: 'white'
    },
  },
  chipSubApp: {
    color: '#8D8D8D',
    fontFamily: 'Montserrat',
    fontWeight: '900',
    fontSize: '16px',
    margin: "0 5px 5px 5px",
    borderColor: `rgb(255,152,109)`,
    "&:hover": {
      color: '#8D8D8D',
    },
  },
  textSearch: {
    padding: "0 30px 0px 0px",
    fontFamily: 'Montserrat',
    fontSize: '15px',
  },
  mainPanelContent: {
    width: "95%",
    margin: "10px 0px 0px 10px",
  },
  cardIcon: {
    width: 30,
  },
  cardRootPublicity: {
    backgroundColor: 'transparent',
    maxWidth: 368,
    width: 368,
    maxHeight: 200,
    margin: "5px 5px 10px 5px",
    cursor: 'pointer',
    "&:hover": {
      boxShadow: `0 0 20px #000000`,
    },
  },

  cardRoot: {
    maxWidth: 368,
    width: 368,
    minHeight: 350,
    height: 350,
    margin: "5px 5px 10px 5px",
    cursor: 'pointer',
    "&:hover": {
      boxShadow: `0 0 20px #000000`,
    },
  },
  cardMedia: {
    height: "100%",
    width: "100%"
  },
  cardContent: {
    backgroundColor: '#FFFFFF',
    paddingBottom: 3,
    height: "100%"
  },

  cardTitle: {

    color: '#4A4A4A',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: '0',
    lineHeight: '19px',
    margin: '0px 0 3px 0',
  },
  cardTitleDate: {
    fontFamily: 'Montserrat',
    color: '#0091FF',
    fontSize: 13,
    // padding: '4px 0 3px 0',
  },

  cardSubTitle: {
    color: '#161831',
    paddingRight: 30,
    color: '#161831',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0',
    lineHeight: '15px',
    borderRight: "0.6px solid #00A4FF",
  },
  cardText: {
    height: 70,
    color: '#4A4A4A',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '15px',
    textAling: 'justify',
    marginTop: 6,
  },
  divider: {
    width: "100%",
    height: "10px",
    backgroundColor: 'red',
  },
  footer: {
    paddingTop: '40px',
    // backgroundColor: '#161831',
    textAlign: 'center',
    color: 'white',
    width: "100%",
  },

  footerImg: {
    backgroundColor: '#161831',
    width: "100%",
    height: 200,
  },
  SocialBtn: {
    margin: '5px 0px 5px 0',
    color: 'white',
    background: 'Transparent',
    fontSize: 13,
    padding: 0,
    fontWeight: 'bold',
    fontFamily: 'Montserrat',
    textAlign: 'left',
  },

  SocialBtnApp: {
    margin: '5px 0px 5px 0',
    color: 'white',
    background: 'Transparent',
    fontSize: 8,
    padding: 0,
    fontWeight: 'bold',
    fontFamily: 'Montserrat',
    textAlign: 'left',
  },
  SocialIcons: {
    background: 'white',
    color: '#161831',
    padding: 5,
    borderRadius: 100,
  },

  SocialIconsApp: {
    background: 'white',
    color: '#161831',
    padding: 2,
    borderRadius: 100,
  },
  copyright: {
    width: "100%",
    fontFamily: 'Montserrat',
    color: '#161831',
    fontSize: '13px',
    fontWeight: "bold",
    marginTop: 3,
  },
  footerContentText: {
    backgroundColor: "white",
    padding: "10px 0px 0px 0px",
  },
  footerText: {
    fontFamily: 'Montserrat',
    fontWeight: "bold",
    color: '#161831',
    // margin: 5,
    fontSize: "70%",
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: 30,
    padding: 10,
    "&:hover": {
      background: `#D6DBE2`,
    },
  },
  menuSearch: {
    width: "0px",
    textAling: 'left',
    padding: "30px 15px 40px 0",
    backgroundColor: "#F9F9F8",
  },
  rootSearch: {
    padding: '0px 4px 0 30px',
    display: 'flex',
    alignItems: 'center',
    width: "500px",
    backgroundColor: "#F9F9F8",
  },
  rootSearchInput: {
    padding: '0px 4px 0 20px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: "white",
    width: "173px",
    height: '42px',
    border: '1px solid #979797',
    borderRadius: 11,
  },
  rootSearchOrdering: {
    marginLeft: 15,
    padding: '0px 0px 0 20px',
    margin: "0 auto",
    display: 'flex',
    alignItems: 'center',
    backgroundColor: "#F9F9F8",
    width: "150px",
    height: '42px',
    border: '1px solid #979797',
    borderRadius: 11,
    cursor: 'pointer',
    "&:hover": {
      backgroundColor: '#E6E3EE',
    },
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    backgroundColor: 'white',
    paddingLeft: 30,
    borderColor: '#EEEEEE',
    borderRadius: 30,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  rootAppbar: {
    flexGrow: 1,
    marginBottom: 70
  },
  appbar: {
    backgroundColor: 'white',
    boxShadow: `2 0 4px 0px #000000`,
  },
  appbarSub: {
    backgroundColor: '#1A1C36',
    width: "100%",
    height: 55,
  },
  iconAppbar: {
    color: '#161731'
  },

  menuButtonAppbar: {
    marginRight: theme.spacing(2),
  },
  titleAppbar: {
    flexGrow: 1,
    textAlign: 'center'
  },
  imgAppbar: {
    width: 74,
    maxHeight: 52,
    marginTop: 5
  },
  imgAppbarApp: {
    width: 74,
    maxHeight: 52,
    marginTop: 5
  },
  rootSearchApp: {
    margin: '0px 6px 0 6px',
    // padding: '0px 20px 0 10px',
    display: 'flex',
    alignItems: 'center',
    width: "95%",
    backgroundColor: '#EEEEEE',
    borderBottom: "1px solid white"
  },
  textApp: {
    marginLeft: theme.spacing(1),
    flex: 1,
    textAlign: 'right',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: "bold",
  },
  margin: {
    margin: "0 !important",
    padding: "0 !important"
  },
  contentWait: {
    margin: "100px 0px 100px 0",
    width: "100%",
    textAlign: 'center',
  },
  contentWaitImg: {
    width: "10%",
    minWidth: "150px",
    padding: 0,
    margin: 0,
  },

  contentWaitText: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    position: 'absolute',
    top: "50%",
    bottom: "50%",
    left: "45%",
    right: "55%",
    color: 'red'
  },
  IconFooter: {
    height: 160,
    width: 240,
    padding: 0,
    margin: "10px 0px 0px 10px",
  },
  IconFooterApp: {
    height: 80,
    width: 120,
    padding: 0,
    // margin: "10px 0px 0px 10px",
  },
  btn: {
    background: `#00A4FF`,
    color: 'white'
  },
  btnFacebook: {
    backgroundColor: `#3b5998`,
    color: 'white',
    margin: 10,
    "&:hover": {
      background: `rgb(241,231,231)`,
      color: 'black',
    },
  },
  btnBack: {
    marginTop: 30,
    marginLeft: 50,
    textAlign: 'left',
    width: 100,
    fontWeight: 'bold',
    fontFamily: 'Montserrat',
    color: '#00A4FF',
  },
  contentTitle: {
    borderTop: "1px solid #DFDFDF",
    padding: "15px 53px 15px 53px",
  },
  btnWhatsapp: {
    backgroundColor: `#00bb2d`,
    color: 'white',
    margin: 10,
    "&:hover": {
      background: `rgb(241,231,231)`,
      color: 'black',
    },
  },
  containerShare: {
    textAlign: 'center',
  },
  containerMedia: {
    textAlign: 'center',
    // background: `#00A4FF`,
  },
  contenCategory: {
    fontWeight: 'bold',
    fontFamily: 'Montserrat',
    color: '#00A4FF',
    fontSize: 20,
  },
  containerTitleDescription: {
    fontFamily: 'Montserrat',
    fontSize: "14px",
    textAlign: "justify",
    color: '#4B4B4B',
    lineHeight: '25px',
  },
  contentHeader: {
    // color: '#00A4FF',
    fontFamily: 'Montserrat',
    padding: 0,
    margin: 0,
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  contentHeaderApp: {
    // color: '#00A4FF',
    fontFamily: 'Montserrat',
    padding: 0,
    margin: 0,
    fontSize: 13,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  headerTitleMenu: {
    // color: '#00A4FF',
    fontFamily: 'Montserrat',
    fontSize: 20,
    padding: 20,
    marginBottom: 10,
    textAlign: 'center',
    borderBottom: "1px solid #EEEEEE",

  },
  contentVideo: {
    width: "100%",
    height: "100%",
    color: 'black',
    maxHeight: "350px"
  },
  btnEmail: {
    zIndex: 1000,
    position: "fixed",
    top: "85%",
    right: 10,
    backgroundColor: '#0091FF',
    color: 'white',
  },
  cardTitleModal: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  cardHeaderModal: {
    boxShadow: `-5px -10px 1px #1A1C36`,
    background: `#00A4FF`
  },
  textModal: {
    textAlign: 'justify',
  },
  contentPublished: {
    fontFamily: 'Montserrat',
  },
  containerDetail: {
    padding: "10px 30px 10px 30px",
    // backgroundColor: 'red',
  },
  IconDrawerMenu: {
    width: 74,
    height: 52,
    paddingLeft: "15%",
  },
  DrawerMenuAppBar: {
    backgroundColor: '#F8F9FA',
  },
  chipApp: {
    fontFamily: 'Poppins',
    background: 'Transparent',
    // margin: "7px 10px 7px 10px",
    // borderRadius: "5px",

  },
  cardRootSuscription: {
    cursor: 'pointer',
    background: '#00A4FF',
    maxWidth: 368,
    width: 368,
    minHeight: 350,
    height: 350,
    margin: "5px 5px 10px 5px",
  },
  cardRootSuscriptionBorder: {
    background: '#00A4FF',
    maxWidth: 368,
    width: 368,
    height: 10,
  },
  cardRootSuscriptionMensaje: {
    height: '140px',
    width: '267px',
    color: '#FFFFFF',
    fontFamily: 'Montserrat',
    fontSize: '30px',
    fontWeight: 'bold',
    letterSpacing: 0,
    lineHeight: '35px',
    margin: "0 auto",
    paddingTop: "30px",
  },
  cardRootSuscriptionBtn: {
    margin: "15px 0px 30px 0",
    height: '60px',
    width: '100%',
    color: "black",
    background: 'white',
    fontFamily: 'Montserrat',
  },
  DrawerMenuHeader: {
    paddingRight: 100,
    width: "100%",
    Height: "134px",
    background: "linear-gradient(356deg, rgba(29,29,53,1) 24%, rgba(0,163,250,1) 100%)",
  },
  DrawerListItem: {
    color: 'white',
    fontFamily: 'Montserrat',
  },
  DrawerListSubItem: {
    color: 'white',
    fontSize: '13px',
    fontFamily: 'Montserrat',
  },
  AppBarContentCard: {
    background: 'rgba(17,17,17,0.8)',
    color: 'white',
    fontSize: 10,
    fontFamily: 'Montserrat',
    padding: "10px 0px 0px 2%",
    height: 47,
    width: "100%",
    bottom: 58,
    position: "relative",
  },
  IconContentCard: {
    width: 50,
    height: 35,
  },
});

export default appStyle;
